import axios from "~/plugins/axios";

export default {
  getDefinitions() {
    return axios.get("/web_api/v1/templating/definition").then((response) => response.data);
  },
  getDefinitionByClass(className) {
    return axios.post("/web_api/v1/templating/definition/by_class", { class: className }).then((response) => response.data);
  },
  getDefinitionByDefinitionClass(className) {
    return axios.post("/web_api/v1/templating/definition/by_definition_class", { definition_class: className }).then((response) => response.data);
  },
  getDefaultAttributesByClass(className) {
    return axios.post("/web_api/v1/templating/definition/default_attributes_by_class", { class: className }).then((response) => response.data);
  },
  getDefinitionByCategoryId(categoryId) {
    return axios.post("/web_api/v1/templating/definition/by_category_id", { category_id: categoryId }).then((response) => response.data);
  },
  getGeneralDefinition() {
    return axios.get("/web_api/v1/templating/definition/general")
      .then((response) => response.data);
  },
};
